import PropTypes from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  saveUserRequestActionCreator,
  currentUserReportActionCreator,
  currentSavedUserReportActionCreator,
  fetchUserReportDefinitionsRequestActionCreator,
  saveDefaultLaunchPageRequestActionCreator,
} from "../../user/redux/actions/UserActions";
import { selectTabActionCreator } from "../redux/actions/DashboardActions";
import { getDashboardProps } from "../redux/selectors/DashboardSelectors";
import DashboardTabTypes from "../redux/actions/types/DashboardTabTypes";
import DashboardAllReportsContainer from "./DashboardAllReportsContainer";
import DashboardMyReportsContainer from "./DashboardMyReportsContainer";
import capeNotificationContainer from "../../common/CapeNotificationContainer";
import ButtonTabs from "../../../core/modules/common/components/ButtonTabs";
import { clearReportCustomFilter } from "../../report/common/redux/actions/ReportsActions";
import {
  getLaunchPage,
  getUserLoaded,
} from "../../user/redux/selectors/UserReportSelectors";
import Button from "../../../core/modules/common/components/Button";
import themeStyles from "../../../materialUiTheme";
import ApplicationsContainer from "./ApplicationsContainer";

export const tabs = [
  {
    value: DashboardTabTypes.MY_REPORTS,
    label: "MY REPORTS",
  },
  {
    value: DashboardTabTypes.ALL_REPORTS,
    label: "ALL REPORTS",
  },
  {
    value: DashboardTabTypes.APPLICATIONS,
    label: "APPLICATIONS",
  },
];

export const defaultTab = "ALL_REPORTS";

export class DashboardContainer extends Component {
  componentDidMount() {
    this.props.currentUserReportActionCreator("");
    this.props.currentSavedUserReportActionCreator("");
    this.props.clearReportCustomFilter();

    // Only fetch user data if not already loaded
    if (!this.props.userLoaded) {
      this.props.fetchUserReportDefinitionsRequestActionCreator();
    }
    this.props.saveUserRequestActionCreator();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.launchPage !== this.props.launchPage) {
      this.props.selectTabActionCreator(
        this.props.dashboard.activeTab || this.props.launchPage
      );
    }
  }

  setDefaultLaunchPage = () => {
    let type;
    if (
      this.props.dashboard.activeTab &&
      this.props.dashboard.activeTab === "MY_REPORTS"
    ) {
      type = "MY";
    } else if (
      this.props.dashboard.activeTab &&
      this.props.dashboard.activeTab === "ALL_REPORTS"
    ) {
      type = "ALL";
    } else {
      type = "APP";
    }
    this.props.saveDefaultLaunchPageRequestActionCreator(type);
  };

  navigateTab = (activeTab) => this.props.selectTabActionCreator(activeTab);

  isAllReportsActive = () =>
    this.props.dashboard.activeTab === DashboardTabTypes.ALL_REPORTS;

  isMyReportsActive = () =>
    this.props.dashboard.activeTab === DashboardTabTypes.MY_REPORTS;

  isApplicationsActive = () =>
    this.props.dashboard.activeTab === DashboardTabTypes.APPLICATIONS;

  render() {
    const {
      dashboard: { activeTab },
    } = this.props;
    return (
      <div className="dashboard">
        <div className="dashboard-tabs">
          <ButtonTabs
            tabs={tabs}
            activeTab={activeTab || this.props.launchPage}
            onChange={this.navigateTab}
            dashboard
          />
          <Button
            className="default-launch-page-button"
            text="app.button.default-launch-page"
            disabled={activeTab === this.props.launchPage}
            style={
              activeTab === this.props.launchPage
                ? themeStyles.blueButton.disabled
                : themeStyles.blueButton
            }
            onClick={this.setDefaultLaunchPage}
          />
        </div>
        {this.isAllReportsActive() && <DashboardAllReportsContainer />}
        {this.isMyReportsActive() && <DashboardMyReportsContainer />}
        {this.isApplicationsActive() && <ApplicationsContainer />}
      </div>
    );
  }
}

DashboardContainer.propTypes = {
  dashboard: PropTypes.objectOf(PropTypes.shape),
  userLoaded: PropTypes.bool,
  selectTabActionCreator: PropTypes.func,
  clearReportCustomFilter: PropTypes.func,
  saveUserRequestActionCreator: PropTypes.func,
  currentUserReportActionCreator: PropTypes.func,
  currentSavedUserReportActionCreator: PropTypes.func,
  fetchUserReportDefinitionsRequestActionCreator: PropTypes.func,
  saveDefaultLaunchPageRequestActionCreator: PropTypes.func,
  launchPage: PropTypes.string,
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      selectTabActionCreator,
      clearReportCustomFilter,
      saveUserRequestActionCreator,
      currentUserReportActionCreator,
      currentSavedUserReportActionCreator,
      fetchUserReportDefinitionsRequestActionCreator,
      saveDefaultLaunchPageRequestActionCreator,
    },
    dispatch
  );

const mapStateToProps = (state) => ({
  dashboard: getDashboardProps(state),
  userLoaded: getUserLoaded(state),
  launchPage: getLaunchPage(state),
});

export const ConnectedDashboardContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(DashboardContainer);

export default capeNotificationContainer(ConnectedDashboardContainer);
